import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=0001ef6e&scoped=true&"
import script from "./bind-phone.vue?vue&type=script&lang=js&"
export * from "./bind-phone.vue?vue&type=script&lang=js&"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=0001ef6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001ef6e",
  null
  
)

export default component.exports